import { useQuery } from '@tanstack/react-query';
import getCorporateCardList from '~apis/corporate-card/getCorporateCardList';

export const USE_GET_CORPORATE_CARD_LIST_QUERY = {
  root: ['corporate-card-list'],
  default: (companyId: string) => [...USE_GET_CORPORATE_CARD_LIST_QUERY.root, companyId],
};
export default function useGetCorporateCardList(companyId?: string) {
  return useQuery(
    USE_GET_CORPORATE_CARD_LIST_QUERY.default(companyId as string),
    () => getCorporateCardList(companyId as string),
    {
      enabled: !!companyId,
      refetchOnMount: true,
    },
  );
}
